import { UsersModule } from "./store/modules/UsersModule";
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Validation from "./plugins/validation";
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import axios from "axios";
import router from "@/router";
import env from "@/env";
import DatetimePicker from "vuetify-datetime-picker";
import { RawLocation } from "vue-router";

// Toast Notifications
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
// global CSS
import "@/styles/global.css";

axios.defaults.baseURL = env.BACKEND_BASE_URL;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(undefined, async function (error) {
  if (error.response?.status === 401) {
    await UsersModule.logout();
  }
  return Promise.reject(error);
});

Vue.config.productionTip = false;

Vue.use(Validation);

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  // "md" (default), "fa", "mdi"
  iconsGroup: "mdi",
});

Vue.use(DatetimePicker);

Vue.mixin({
  methods: {
    async routerPush(this: Vue, route: RawLocation): Promise<void> {
      try {
        await this.$router.push(route);
      } catch (error: any) {
        if (
          error instanceof Error &&
          error.name !== "NavigationDuplicated" &&
          !error.message.includes(
            "Avoided redundant navigation to current location"
          )
        ) {
          throw error;
        }
      }
    },
  },
});

Vue.use(Toast, {
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
